import { inject, Injectable } from '@angular/core'
import { UserGroupPermissionId } from '@ftr/contracts/api/user-group'
import { HelpMenuItemsProvider } from '@ftr/ui-help'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'
import { combineLatest, map, Observable } from 'rxjs'
import { getAccessNavItemsGroup } from '../access-nav-items'
import { ADMIN_NAV_GROUP } from '../admin-nav-items'
import { toSideNavItem } from '../help-support'
import { PLANS_NAV_GROUP } from '../plans-nav-items'
import { REQUEST_NAV_ITEMS_GROUP } from '../request-nav-items'
import { SideNavItem } from '../side-nav-item'
import { SideNavProviderResult } from '../side-nav-provider-result'

@Injectable({
  providedIn: 'root',
})
export class PublicSideNavItemsProvider {
  private readonly store = inject(Store)
  private readonly helpMenuItemsProvider = inject(HelpMenuItemsProvider)

  provide(): Observable<SideNavProviderResult> {
    const helpSupportFlyoutItems = this.helpMenuItemsProvider.provide({ mode: 'public' })
    return combineLatest([
      this.store.select(UserState.isLoggedIn),
      this.store
        .select(UserState.hasPermissionInAnyCourtSystem)
        .pipe(map(fn => fn(UserGroupPermissionId.TranscribeRecordings))),
    ]).pipe(
      map(([isLoggedIn, hasTranscriberPermissions]) => {
        const helpBranchItem: SideNavItem = {
          type: 'BRANCH',
          title: 'Help & Support',
          icon: 'HelpCircleLine',
          displayMode: 'OVERLAY',
          children: helpSupportFlyoutItems().map(toSideNavItem),
        } as SideNavItem
        return {
          navGroups: isLoggedIn
            ? [REQUEST_NAV_ITEMS_GROUP, getAccessNavItemsGroup(hasTranscriberPermissions), ADMIN_NAV_GROUP]
            : [REQUEST_NAV_ITEMS_GROUP, PLANS_NAV_GROUP],
          footerItems: [helpBranchItem],
        }
      }),
    )
  }
}
